<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h4 class="mb-10 mt-3">Nouvelle Réclamation</h4>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form @submit.prevent="addClaim" class="row">
        <div class="col-md-12 form-group mb-3">
          <label for="type" class="form-label">Type de réclamation *</label>
          <v-select
            label="name"
            :options="objects"
            v-model="object"
            class="custom-select-height"
          />
        </div>

        <div
          v-if="
            object?.name == 'Changement Adresse/Client' ||
            object?.name == 'Changement de prix' ||
            object?.name == 'Annulation Colis' ||
            object?.name == 'Relance Colis/Client' ||
            object?.name == 'Rembourssement'
          "
          class="col-md-12 form-group mb-3"
        >
          <label for="code" class="form-label">Code Colis *</label>
          <input
            id="code"
            @change="checkCode()"
            v-model="code_colis"
            placeholder="Code d'envoie"
            type="text"
            class="form-control"
          />
        </div>

        <div
          v-if="object?.name == 'Changement de prix'"
          class="col-md-12 form-group mb-3"
        >
          <label for="price" class="form-label">Nouveau prix *</label>
          <input
            id="price"
            name="price"
            v-model="form.price"
            type="number"
            min="0"
            placeholder="Nouveau prix *"
            class="form-control"
          />
        </div>

        <div
          v-if="object?.name == 'Rembourssement'"
          class="col-md-12 form-group mb-3"
        >
          <label for="priceRemb" class="form-label">Prix à rembourser *</label>
          <input
            id="priceRemb"
            name="priceRemb"
            v-model="form.priceRemb"
            type="number"
            min="0"
            placeholder="Prix à rembourser *"
            class="form-control"
          />
        </div>

        <div class="col-md-12 form-group mb-3">
          <label for="city" class="form-label">Ville *</label>
          <v-select
            class="custom-select-height"
            v-model="city"
            label="name"
            :options="citiesList"
          />
        </div>

        <div
          v-if="object?.name == 'Changement Adresse/Client'"
          class="col-md-12 form-group mb-3"
        >
          <label for="Adresse" class="form-label">Nouveau Adresse</label>
          <textarea
            id="Adresse"
            name="Adresse"
            rows="2"
            v-model="form.adresse"
            placeholder="Nouveau Adresse"
            class="form-control"
          ></textarea>
        </div>

        <div
          v-if="object?.name == 'Changement Adresse/Client'"
          class="col-md-12 form-group mb-3"
        >
          <label for="reciever" class="form-label">Nouveau Destinataire</label>
          <input
            id="reciever"
            name="reciever"
            v-model="form.reciever"
            placeholder="Nouveau Destinataire"
            class="form-control"
          />
        </div>

        <div
          v-if="object?.name == 'Changement Adresse/Client'"
          class="col-md-12 form-group mb-3"
        >
          <label for="phone" class="form-label">Nouveau Numéro Téléphone</label>
          <input
            id="phone"
            name="phone"
            type="text"
            pattern="[0-9]*"
            v-model="form.phone"
            placeholder="Nouveau Numéro Téléphone"
            maxlength="10"
            class="form-control"
          />
        </div>

        <div class="col-md-12 form-group mb-3">
          <label for="msg" class="form-label">Message *</label>
          <textarea
            id="msg"
            name="msg"
            rows="2"
            v-model="form.msg"
            placeholder="Message *"
            class="form-control"
          ></textarea>
        </div>

        <div class="col-md-12">
          <button type="submit" class="btn btn-primary">
            <span class="text-nowrap">Enregistrer</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const citiesList = ref<string[]>([]);
    const objects = ref<string[]>([]);
    const city = ref<any>({});
    const code_colis = ref<string>("");
    const error = ref<boolean>(false);
    const colisList = ref<any[]>([]);
    const object = ref<any>({});


    const form = reactive({
      object: "",
      code_colis: "",
      price: null,
      priceRemb: null,
      adresse: "",
      reciever: "",
      phone: "",
      msg: "",
    });

    onMounted(async () => {
      try {
        const response = await api.get("/api/auth/client/fetchObject");
        objects.value = response.data;
      } catch (error) {
        console.error("Error fetching form data:", error);
        showToast(
          "Erreur lors de la récupération des données du formulaire.",
          "error"
        );
      }

      try {
        const response = await api.get("/api/auth/client/citiesList");
        citiesList.value = response.data;
      } catch (error) {
        console.error("Error fetching form data:", error);
        showToast(
          "Erreur lors de la récupération des données du formulaire.",
          "error"
        );
      }
    });

    function checkCode(){
        
      if (
        code_colis.value &&
        (
          object.value.name == "Changement Adresse/Client" ||
          object.value.name == "Annulation Colis" ||
          object.value.name == "Relance Colis/Client"
        )
      ) {
        error.value = true;
      } else {
        error.value = false;
      }
    }

    async function addClaim() {
      // Validation
      if (
        !object.value ||
        !city.value ||
        !form.msg
      ) {
        showToast("Merci de remplir tous les champs obligatoires.", "error");
        return;
      }

      if (
        (!code_colis.value || code_colis.value === "") &&
        (
          object.value.name == "Changement Adresse/Client" ||
          object.value.name == "Changement de prix" ||
          object.value.name == "Annulation Colis" ||
          object.value.name == "Relance Colis/Client"
        )
      ) {
        showToast("Merci de saisir le code d'envoi du colis.", "error");
        return;
      }

      if (
        object.value.name == "Changement de prix" &&
        !form.price
      ) {
        showToast("Merci de remplir le nouveau prix.", "error");
        return;
      }

      if (
        object.value.name == "Rembourssement" &&
        !form.priceRemb
      ) {
        showToast("Merci de remplir le prix à rembourser.", "error");
        return;
      }

      // Prepare data
      const data = new FormData();
      data.append("object", object.value.name);
      data.append("object_id", object.value.id);
      data.append("city_id", city.value.id);
      data.append("code_colis", code_colis.value);
      data.append("msg", form.msg);
      data.append("adresse", form.adresse);
      data.append("reciever", form.reciever);
      data.append("price", form.price ?? "");
      data.append("priceRemb", form.priceRemb ?? "");
      data.append("phone", form.phone);
      data.append("market", JSON.parse(localStorage.getItem("st") || "{}").id);

      try {
        const res = await api.post("/api/auth/client/AddClaims", data);
        if (res.data === "success") {
          Object.assign(form, {
            object: "",
            code_colis: "",
            price: null,
            priceRemb: null,
            adresse: "",
            reciever: "",
            phone: "",
            msg: "",
          });
          object.value = null;
          city.value = null;
          code_colis.value = "";
          showToast("Vos données sont bien enregistrées.", "success");
        } else if (res.data === "code required") {
          showToast("Merci de saisir le code d'envoi du colis.", "error");
        } else if (res.data === "fields required") {
          showToast("Merci de remplir les champs obligatoires.", "error");
        } else if (res.data === "no parcel") {
          showToast("Aucun colis existe avec ce code.", "error");
        } else if (res.data === "error status") {
          showToast("Vous ne pouvez pas réclamer ce colis.", "error");
        } else if (res.data === "no customer") {
          showToast("Vous ne pouvez pas ajouter une réclamation.", "error");
        } else {
          showToast("Une erreur est survenue.", "error");
        }
      } catch (err) {
        showToast("Une erreur est survenue. Veuillez réessayer.", "error");
      }
    }

    return {
      user,
      citiesList,
      objects,
      city,
      code_colis,
      form,
      error,
      colisList,
      showToast,
      checkCode,
      addClaim,
      object
    };
  },
});
</script>


